import iconDashboard from '@/assets/icons/dashboard.svg';
import iconApps from '@/assets/icons/apps.svg';
import iconBox from '@/assets/icons/box.svg';
import iconDashboardPurple from '@/assets/icons/dashboard-purple.svg';
import iconAppsPurple from '@/assets/icons/apps-purple.svg';
import iconBoxPurple from '@/assets/icons/box-purple.svg';
import iconArticle from '@/assets/icons/article.svg';
import iconArticleSelected from '@/assets/icons/article-selected.svg';
import iconUsers from '@/assets/icons/users.svg';
import iconUsersPurple from '@/assets/icons/users-purple.svg';
import iconDirectory from '@/assets/icons/folder-open.svg';
import iconDirectoryPurple from '@/assets/icons/folder-open-purple.svg';
import iconApis from '@/assets/icons/apis.svg';
import iconApisPurple from '@/assets/icons/apis-purple.svg';
import iconService from '@/assets/icons/service.svg';
import iconServicePurple from '@/assets/icons/service-purple.svg';
import env from '@/env';
import { getWebAppInfo } from '@/utils';

export enum MenuVisibility {
  ROOT,
  SUBDOMAIN,
}

const webApp = getWebAppInfo(env.siteId);

const menus = [
  {
    icon: iconDirectory,
    iconActive: iconDirectoryPurple,
    label: 'My Directory',
    to: `https://${webApp.domain}/dashboard/my-directory`,
    requiredRoles: [env.roles.superAdmin, env.roles.directoryAdmin],
    visibility: [MenuVisibility.ROOT, MenuVisibility.SUBDOMAIN],
    absolutePath: true,
  },
  {
    icon: iconDashboard,
    iconActive: iconDashboardPurple,
    label: `My ${webApp.appName === 'DakkoHub' ? 'Organization' : 'Organisation'}`,
    to: 'my-organisation',
    requiredRoles: [],
    visibility: [MenuVisibility.SUBDOMAIN],
    absolutePath: false,
  },
  {
    icon: iconService,
    iconActive: iconServicePurple,
    label: 'My Services',
    to: 'my-services',
    requiredRoles: [],
    visibility: [MenuVisibility.SUBDOMAIN],
    absolutePath: false,
  },
  {
    icon: iconApps,
    iconActive: iconAppsPurple,
    label: 'My Apps',
    to: 'my-apps',
    requiredRoles: [],
    visibility: [MenuVisibility.SUBDOMAIN],
    absolutePath: false,
  },
  {
    icon: iconBox,
    iconActive: iconBoxPurple,
    label: 'My Portal',
    to: 'my-portal',
    requiredRoles: [env.roles.bankAdmin, env.roles.apiPublisher, env.roles.superAdmin, env.roles.directoryAdmin],
    visibility: [MenuVisibility.SUBDOMAIN],
    absolutePath: false,
  },
  {
    icon: iconArticle,
    iconActive: iconArticleSelected,
    label: 'My Articles',
    to: 'my-articles',
    requiredRoles: [env.roles.superAdmin, env.roles.directoryAdmin],
    visibility: [MenuVisibility.ROOT],
    absolutePath: false,
  },
  {
    icon: iconUsers,
    iconActive: iconUsersPurple,
    label: 'My Visitors',
    to: 'my-visitors',
    requiredRoles: [env.roles.superAdmin, env.roles.directoryAdmin],
    visibility: [MenuVisibility.ROOT],
    absolutePath: false,
  },
  {
    icon: iconApis,
    iconActive: iconApisPurple,
    label: 'API Categories',
    to: 'api-categories',
    requiredRoles: [env.roles.superAdmin, env.roles.directoryAdmin],
    visibility: [MenuVisibility.ROOT],
    absolutePath: false,
  },
  {
    icon: iconApis,
    iconActive: iconApisPurple,
    label: 'APP Features',
    to: 'app-categories',
    requiredRoles: [env.roles.superAdmin, env.roles.directoryAdmin],
    visibility: [MenuVisibility.ROOT],
    absolutePath: false,
  },
  {
    icon: iconService,
    iconActive: iconServicePurple,
    label: 'Service Categories ',
    to: 'service-categories',
    requiredRoles: [env.roles.superAdmin, env.roles.directoryAdmin],
    visibility: [MenuVisibility.ROOT],
    absolutePath: false,
  },
  {
    icon: iconBox,
    iconActive: iconBoxPurple,
    label: 'My Account',
    to: 'my-account',
    requiredRoles: [env.roles.bankAdmin, env.roles.apiPublisher, env.roles.superAdmin, env.roles.directoryAdmin],
    visibility: [MenuVisibility.SUBDOMAIN, MenuVisibility.ROOT],
    absolutePath: false,
  },
];

export { menus };
